import React from 'react';
import { useForm } from 'react-hook-form';
import './reportform.css';
import { useEffect } from 'react';
import { Controller } from "react-hook-form";
import DatePicker from 'react-datepicker';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import Select from 'react-select';
import ReactCountryFlag from 'react-country-flag';


const CustomerInjusry = ({ onReview, goBack, defaultValues }) => {
  const alphaNumericSpaceRegex = /^[A-Za-z\s]+$/;
  const numericRegex = /^[0-9]+$/;

  const store_id = sessionStorage.getItem("store_id");
  const manager = sessionStorage.getItem("first_name");

  const { register, handleSubmit, watch, formState: { errors }, control } = useForm({
    shouldFocusError: false,
    defaultValues: {
      store_id,
      reported_by: manager,
      country_code: '+91',
      ...defaultValues,
      incident_date: defaultValues?.incident_date ? new Date(defaultValues.incident_date) : null,
      incident_time: defaultValues?.incident_time ? new Date(defaultValues.incident_time) : null,
      reported_date: defaultValues?.reported_date ? new Date(defaultValues.reported_date) : new Date(),
    }
  });

  const selectedCountryCode = watch("country_code");


  const countryCodes = React.useMemo(() => {
    const countries = getCountries();
    const countryData = countries.map(country => {
      const callingCode = `+${getCountryCallingCode(country)}`;

      const maxDigitsMap = {
        'US': 10, 'CA': 10, 'IN': 10, 'GB': 10, 'AU': 9,
        'JP': 10, 'CN': 11, 'DE': 11, 'FR': 9, 'IT': 10, 'ES': 9
      };

      return {
        code: callingCode,
        name: country,
        country: country,
        maxDigits: maxDigitsMap[country] || 10
      };
    });

    return countryData.sort((a, b) => {
      const numA = parseInt(a.code.replace('+', ''));
      const numB = parseInt(b.code.replace('+', ''));
      return numA - numB;
    });
  }, []);

  const getMaxDigits = (code) => {
    const country = countryCodes.find(c => c.code === code);
    return country ? country.maxDigits : 10;
  };

  const onSubmit = data => {
    const formattedData = {
      ...data,
      customer_phone: `${data.country_code}${data.customer_phone}`
    };
    console.log(formattedData);

  };

  const selectedIncident = watch("incidentType");

  const submitPreview = handleSubmit(onReview);
  const handlePreview = () => {
    // Resize the floor_description textarea to fit content before preview
    const el = document.querySelector('textarea[name="floor_description"]');
    if (el) {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
    submitPreview();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mx-auto p-6 space-y-6 bg-white shadow rounded w-full">
      <h2 className="text-2xl font-bold mb-4">Team Member Incident</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2 font-medium">Personal Information</label>
          <div className="flex items-center gap-4">
            <label>
              <input
                type="radio"
                value="Male"
                {...register("gender", { required: "Please Select Gender" })}
                className="mr-1"
              />
              Male
            </label>
            <label>
              <input
                type="radio"
                value="Female"
                {...register("gender", { required: "Please Select Gender" })}
                className="mr-1"
              />
              Female
            </label>
          </div>
          {errors.gender && <p className='text-red-500 text-sm mt-1'>{errors.gender.message}</p>}
        </div>

        <div>
          <label className="block mb-2 font-medium">Glasses</label>
          <div className="flex items-center gap-4">
            <label>
              <input
                type="radio"
                value="Yes"
                {...register("glasses", { required: "Please Select yes/no" })}
                className="mr-1"
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                value="No"
                {...register("glasses")}
                className="mr-1"
              />
              No
            </label>
          </div>
          {errors.glasses && <p className='text-red-500 text-sm mt-1'>{errors.glasses.message}</p>}
        </div>

        <div>
          <label className="block mb-2 font-medium">Walking Device</label>
          <div className="flex items-center gap-4">
            <label>
              <input
                type="radio"
                value="Yes"
                {...register("walking_device", { required: "Please Select Option" })}
                className="mr-1"
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                value="No"
                {...register("walking_device", { required: "Please Select Option" })}
                className="mr-1"
              />
              No
            </label>
          </div>
          {errors.walking_device && <p className='text-red-500 text-sm mt-1'>{errors.walking_device.message}</p>}
        </div>

        <h1 className='col-span-2 font-bold'>Address</h1>

        <div>
          <label className="block mb-1 font-medium">Name</label>
          <Controller
            name="customer_name"
            control={control}
            rules={{
              required: "Name is required",
              pattern: {
                value: alphaNumericSpaceRegex,
                message: "Only alphabets and spaces are allowed"
              }
            }}
            render={({ field }) => (
              <input
                value={field.value || ''}
                onChange={(e) => {
                  const filteredValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                  field.onChange(filteredValue);
                }}
                onBlur={field.onBlur}
                ref={field.ref}
                className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            )}
          />
          {errors.customer_name && <p className="text-red-500 text-sm">{errors.customer_name.message}</p>}
        </div>

        <div>
          <label className="block mb-1 font-medium">City</label>
          <Controller
            name="customer_city"
            control={control}
            rules={{
              required: "City is required",
              pattern: {
                value: alphaNumericSpaceRegex,
                message: "Only alphabets and spaces are allowed"
              }
            }}
            render={({ field }) => (
              <input
                value={field.value || ''}
                onChange={(e) => {
                  const filteredValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                  field.onChange(filteredValue);
                }}
                onBlur={field.onBlur}
                ref={field.ref}
                className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            )}
          />
          {errors.customer_city && <p className="text-red-500 text-sm">{errors.customer_city.message}</p>}
        </div>

        <div>
          <label className="block mb-1 font-medium">State</label>
          <Controller
            name="customer_state"
            control={control}
            rules={{
              required: "State is required",
              pattern: {
                value: alphaNumericSpaceRegex,
                message: "Only alphabets and spaces are allowed"
              }
            }}
            render={({ field }) => (
              <input
                value={field.value || ''}
                onChange={(e) => {
                  const filteredValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                  field.onChange(filteredValue);
                }}
                onBlur={field.onBlur}
                ref={field.ref}
                className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            )}
          />
          {errors.customer_state && <p className="text-red-500 text-sm">{errors.customer_state.message}</p>}
        </div>

        <div>
          <label className="block mb-1 font-medium">Zip Code</label>
          <Controller
            name="zip_code"
            control={control}
            rules={{
              required: "Zip Code is required",
              pattern: {
                value: numericRegex,
                message: "Only numbers are allowed"
              }
            }}
            render={({ field }) => (
              <input
                value={field.value || ''}
                onChange={(e) => {
                  const filteredValue = e.target.value.replace(/[^0-9]/g, '');
                  field.onChange(filteredValue);
                }}
                onBlur={field.onBlur}
                ref={field.ref}
                className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            )}
          />
          {errors.zip_code && <p className="text-red-500 text-sm">{errors.zip_code.message}</p>}
        </div>

        <div>
          <label className="block mb-1 font-medium">Phone</label>
          <div className="flex gap-2 items-center">
            <Controller
              name="country_code"
              control={control}
              defaultValue={"+91"} // Default India code
              rules={{ required: "Country code is required" }}
              render={({ field }) => {
                const options = countryCodes.map((country) => ({
                  value: country.code,
                  label: `${country.country} (${country.code})`,
                  country: country.country,
                }));

                const selectedOption =
                  options.find((opt) => opt.value === field.value) ||
                  options.find((opt) => opt.value === "+91") ||
                  options[0];

                return (
                  <div className="w-[240px]">
                    <Select
                      options={options}
                      value={selectedOption}
                      onChange={(selected) => field.onChange(selected.value)}
                      placeholder="Search country..."
                      isSearchable
                      getOptionLabel={(option) => (
                        <div className="flex items-center gap-2">
                          <ReactCountryFlag
                            countryCode={option.country}
                            svg
                            style={{
                              width: "1.2em",
                              height: "1.2em",
                              borderRadius: "2px",
                              objectFit: "cover",
                            }}
                          />
                          <span>{option.country}</span>
                          <span className="text-gray-500 ml-auto">{option.value}</span>
                        </div>
                      )}
                      filterOption={(option, inputValue) => {
                        const searchText = inputValue.toLowerCase();
                        return (
                          option.data.country.toLowerCase().includes(searchText) ||
                          option.data.value.includes(searchText)
                        );
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "42px",
                          borderRadius: "0.5rem",
                          borderColor: state.isFocused ? "#EF7320" : "#d1d5db",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px rgba(239,115,32,0.2)"
                            : "none",
                          "&:hover": { borderColor: "#EF7320" },
                          backgroundColor: "white",
                          cursor: "pointer",
                        }),
                        option: (base, { isFocused, isSelected }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? "#EF7320"
                            : isFocused
                              ? "#FCE8D6"
                              : "white",
                          color: isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          fontSize: "0.875rem",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: "#111827",
                          fontWeight: "400",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }),
                      }}
                    />
                  </div>
                );
              }}
            />







            <Controller
              name="customer_phone"
              control={control}
              rules={{
                required: "Phone Number is required",
                validate: (value) => {
                  const maxDigits = getMaxDigits(selectedCountryCode);
                  if (value && value.length !== maxDigits) {
                    return `Phone number must be exactly ${maxDigits} digits`;
                  }
                  return true;
                },
                pattern: {
                  value: numericRegex,
                  message: "Only numbers are allowed",
                },
              }}
              render={({ field }) => (
                <input
                  value={field.value || ''}
                  onChange={(e) => {
                    const filteredValue = e.target.value.replace(/[^0-9]/g, '');
                    const maxDigits = getMaxDigits(selectedCountryCode);
                    if (filteredValue.length <= maxDigits) {
                      field.onChange(filteredValue);
                    }
                  }}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  placeholder={`Enter ${getMaxDigits(selectedCountryCode)} digits`}
                  className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
              )}
            />
          </div>
          {errors.customer_phone && <p className="text-red-500 text-sm">{errors.customer_phone.message}</p>}
        </div>


        <div>
          <label className="block mb-1 font-medium">Email</label>
          <input {...register("customer_email", { required: 'Email is Required' })} className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
          {errors.customer_email && <p className="text-red-500 text-sm">{errors.customer_email.message}</p>}
        </div>

        <div className="col-span-2">
          <label className="block font-medium mb-1">Description of Accident</label>
          <textarea {...register("accident_description", { required: "Description is required" })}
            rows={4}
            className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500" />
          {errors.accident_description && <p className="text-red-500 text-sm mt-1">{errors.accident_description.message}</p>}
        </div>

        <div>
          <label className="block font-medium mb-1">When Mitra Employee Arrived?</label>
          <Controller
            control={control}
            name="employee_arrived_time"
            rules={{ required: "Select Incident Time" }}
            render={({ field }) => (
              <DatePicker
                {...field}
                selected={field.value}
                onChange={(val) => field.onChange(val)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText="Select time"
                className="w-full border border-gray-300 rounded px-4 py-2 me-22 focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            )}
          />
          {errors.employee_arrived_time && (
            <p className="text-red-500 text-sm mt-1">
              {errors.employee_arrived_time.message}
            </p>
          )}
        </div>

        <div>
          <label className="block mb-2 font-medium">Is area dry?</label>
          <select
            {...register("area_dry", { required: "Please Select an Option" })}
            className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">Select an option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.area_dry && <p className="text-red-500 text-sm">{errors.area_dry.message}</p>}
        </div>

        <div className="col-span-2 flex flex-col sm:flex-row gap-4">
          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-medium">Is anything on the floor?</label>
            <select
              {...register("on_the_floor", { required: "Please Select an Option" })}
              className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="">Select an option</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {errors.on_the_floor && <p className="text-red-500 text-sm">{errors.on_the_floor.message}</p>}
          </div>

          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-medium">Specific Area Incident Occurred</label>
            <select
              {...register("incident_occured", { required: "Please Select an Option" })}
              className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="">Select</option>
              <option value="Outside">Outside</option>
              <option value="Vestibule">Vestibule</option>
              <option value="Entry">Entry</option>
              <option value="Restroom">Restroom</option>
              <option value="Soda Machine">Soda Machine</option>
              <option value="Register Area">Register Area</option>
              <option value="Dinning Room">Dinning Room</option>
            </select>
            {errors.incident_occured && <p className="text-red-500 text-sm mt-1">{errors.incident_occured.message}</p>}
          </div>
        </div>

        {watch("on_the_floor") === "Yes" && (
          <div className="col-span-2">
            <label className="block font-medium mb-1">Describe what was on the floor</label>
            <textarea
              {...register("floor_description", {
                required: "Description is Required",
                maxLength: { value: 750, message: "Maximum 750 characters allowed" }
              })}
              rows={4}
              maxLength={750}
              className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
            {errors.floor_description && (
              <p className="text-red-500 text-sm mt-1">{errors.floor_description.message}</p>
            )}
          </div>
        )}

        <h1 className='col-span-2 font-bold'>Injury Information:</h1>

        <div className="col-span-2 flex flex-col sm:flex-row gap-4">
          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-medium">What body part was injured?</label>
            <select
              {...register("body_part_injured", { required: 'Please Select an Option' })}
              className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="">Select</option>
              <option value="Head">Head</option>
              <option value="Face">Face</option>
              <option value="Neck">Neck</option>
              <option value="Shoulder">Shoulder</option>
              <option value="Arm">Arm</option>
              <option value="Wrist">Wrist</option>
              <option value="Hand">Hand</option>
              <option value="Back">Back</option>
              <option value="Abdomen">Abdomen</option>
              <option value="Legs">Legs</option>
              <option value="Feet">Feet</option>
            </select>
            {errors.body_part_injured && <p className='text-red-500 text-sm mt-1'>{errors.body_part_injured.message}</p>}
          </div>

          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-medium">Which Side of Your Body?</label>
            <select
              {...register("which_side_of_the_body", { required: 'Please Select an Option' })}
              className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="">Select</option>
              <option value="Left">Left</option>
              <option value="Right">Right</option>
              <option value="Both">Both</option>
            </select>
            {errors.which_side_of_the_body && <p className='text-red-500 text-sm mt-1'>{errors.which_side_of_the_body.message}</p>}
          </div>
        </div>

        <div className='col-span-2'>
          <label className="block mb-2 font-medium">Is Authorities Called?</label>
          <select
            {...register("authoritiesCalled", { required: "Please Select an Option" })}
            className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">Select an option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.authoritiesCalled && <p className='text-red-500 text-sm mt-1'>{errors.authoritiesCalled.message}</p>}
        </div>

        {watch("authoritiesCalled") === "Yes" && (
          <div className='col-span-2 flex flex-col sm:flex-row gap-4'>
            <div className="w-full sm:w-1/2">
              <label className="block font-medium mb-1">Authority Name</label>
              <input type='text' placeholder='Enter Authority Name'
                {...register("responding_authority", {
                  required: "Authority Name is required",
                })}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
              {errors.responding_authority && (
                <p className="text-red-500 text-sm mt-1">{errors.responding_authority.message}</p>
              )}
            </div>

            <div className="w-full sm:w-1/2">
              <label className="block font-medium mb-1">Authority Phone Number</label>
              <Controller
                name="report_number"
                control={control}
                rules={{
                  required: "Authority Number is required",
                  pattern: { value: /^[0-9]+$/, message: "Only numbers are allowed" },
                }}
                render={({ field }) => (
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="Enter Authority Number"
                    value={field.value || ''}
                    onChange={(e) => {
                      const filtered = e.target.value.replace(/\D/g, '');
                      field.onChange(filtered);
                    }}
                    onBlur={field.onBlur}
                    ref={field.ref}
                    className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                )}
              />
              {errors.report_number && (
                <p className="text-red-500 text-sm mt-1">{errors.report_number.message}</p>
              )}
            </div>
          </div>
        )}

        <div className="col-span-2 flex flex-col sm:flex-row gap-4">
          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-medium">Is First Aid Provided?</label>
            <select
              {...register("first_aid_provided", { required: "Please Select an Option" })}
              className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {errors.first_aid_provided && <p className='text-red-500 text-sm mt-1'>{errors.first_aid_provided.message}</p>}
          </div>

          <div className="w-full sm:w-1/2">
            <label className="block mb-2 font-medium">Is Ambulance Transport called?</label>
            <select
              {...register("ambulance_transport_called", { required: 'Please Select an Option' })}
              className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            {errors.ambulance_transport_called && <p className='text-red-500 text-sm mt-1'>{errors.ambulance_transport_called.message}</p>}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <div>
          <label className="block mb-1 font-medium">Reported By</label>
          <input {...register("reported_by", { required: "Reported By is Required" })} className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-500" value={manager}
          />
          {errors.reported_by && <p className='text-red-500 text-sm mt-1'>{errors.reported_by.message}</p>}
        </div>

        <div>
          <label className="block font-medium mb-1">Report Date</label>
          <Controller
            control={control}
            name="reported_date"
            defaultValue={new Date()}
            rules={{ required: "Select Reported Date" }}
            render={({ field }) => (
              <DatePicker
                {...field}
                selected={field.value}
                onChange={(val) => field.onChange(val)}
                dateFormat="dd-MMM-yyyy"
                disabled
                className="w-full border border-gray-300 rounded px-4 py-2 me-22 bg-gray-100 cursor-not-allowed"
                placeholderText="Select date"
              />
            )}
          />
          {errors.reported_date && (
            <p className="text-red-500 text-sm mt-1">
              {errors.reported_date.message}
            </p>
          )}
        </div>
      </div>

      <div className='flex row justify-start mt-4 gap-2'>
        <button
          type="button"
          onClick={handlePreview}
          className="bg-[#EF7320] text-white px-4 py-2 mt-4 rounded-lg"
        >
          Preview
        </button>

        <button
          type="button"
          onClick={goBack}
          className="bg-[#EF7320] text-white px-4 py-2 mt-4 rounded-lg"
        >
          Back
        </button>
      </div>
    </form>
  );
}

export default CustomerInjusry;